import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchTenantPriceLists, uploadTenantPriceList } from './api.js'

const QUERY_KEY = ['tenant-price-lists'] as const

export function useTenantPriceLists() {
  return useQuery({ queryKey: QUERY_KEY, queryFn: fetchTenantPriceLists })
}

/**
 * Invalidate, not `setQueryData` — a successful upload can also carry a
 * partial refusal (some rows accepted, some not), and the full version
 * history (the newly-superseded prior row included) is worth re-reading from
 * the server rather than hand-assembled client-side from one response.
 */
export function useUploadTenantPriceList() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: uploadTenantPriceList,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: QUERY_KEY })
    },
  })
}
